import React, { useState, useEffect } from 'react';
import './LoginPage.css';

interface LoginPageProps {
  onLoginSuccess: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const CORRECT_PASSWORD = '1590';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simulate API call with setTimeout
    setTimeout(() => {
      if (password === CORRECT_PASSWORD) {
        // Store authentication in session storage
        sessionStorage.setItem('isAuthenticated', 'true');
        onLoginSuccess();
      } else {
        setError('Incorrect password. Please try again.');
      }
      setIsLoading(false);
    }, 800); // Add slight delay for better UX
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Canada Innovation Chatbot</h1>
          <div className="login-logo">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#E53E3E" stroke="#E53E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
        
        <p className="login-subtitle">
          Access insights on Canada's innovation policy and initiatives from Budget 2024
        </p>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter system password"
              required
            />
            {error && <div className="error-message">{error}</div>}
          </div>
          
          <button 
            type="submit" 
            className={`login-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="button-loader"></div>
            ) : (
              'Access Chatbot'
            )}
          </button>
        </form>
        
        <div className="login-footer">
          <p>Authorized access only. This system contains confidential information.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 